/**
 * TimerUtils - 計時工具集
 */
export class TimerUtils {

    /** TimerUtils的單一實體 */
    private static instance: TimerUtils;


    /** 系統層級 - 登出倒數Timer */
    private logoutTimer: BackgroundTimer;

    /**
     * page層級的timer
     */
    private pageTimer: BackgroundTimer;

    /**
     * 元件層級的timer
     */
    private componentTimer: BackgroundTimer;

    /**
     * private constructor
     */
    private constructor() {

    }

    /**
     * 取得 singleton instance
     */
    static getInstance(): TimerUtils {
        if (TimerUtils.instance == null) {
            TimerUtils.instance = new TimerUtils();
        }
        return TimerUtils.instance;
    }

    /**
     * 啟動登出倒數Timer
     *
     * @param countSec - 總倒數秒數
     * @param callback - 每秒會呼叫的callback(秒數)
     */
    startLogoutTimer(countSec: number, callback: (second: number) => void) {
        // 先終止已存在的timer
        this.cancelLogoutTimer();

        this.logoutTimer = new BackgroundTimer(countSec, (second) => {
            if (second < 0) {
                second = 0;
            }
            callback(second);

            if (second === 0) {
                this.cancelLogoutTimer();
            }
        });

        this.logoutTimer.start();
    }

    /**
     * 重置登出倒數Timer
     * @param callback - reset後回呼的callback
     */
    resetLogoutTimer(callback: () => void) {
        if (this.logoutTimer != null) {
            this.logoutTimer.reset();
            callback();
        }
    }

    /**
     * 中斷登出倒數Timer
     */
    cancelLogoutTimer() {
        if (this.logoutTimer != null) {
            this.logoutTimer.cancel();
            this.logoutTimer = null;
        }
    }

    /**
     * 啟動page層級Timer
     * @param countSec - 總倒數秒數
     * @param callback - 每秒會呼叫的callback(秒數)
     */
    startPageTimer(countSec: number, callback: (second: number) => void): void {
        // 先終止已存在的timer
        this.cancelPageTimer();

        this.pageTimer = new BackgroundTimer(countSec, (second) => {
            if (second < 0) {
                second = 0;
            }
            callback(second);

            if (second === 0) {
                this.cancelPageTimer();
            }
        });

        this.pageTimer.start();
    }

    /**
     * 重置Page層級Timer
     */
    resetPageTimer() {
        if (this.pageTimer != null) {
            this.pageTimer.reset();
        }
    }

    /**
     * 中斷Page層級Timer
     */
    cancelPageTimer() {
        if (this.pageTimer != null) {
            this.pageTimer.cancel();
            this.pageTimer = null;
        }
    }

    /**
     * 啟動元件層級Timer
     * @param countSec - 總倒數秒數
     * @param callback - 每秒會呼叫的callback(秒數)
     */
    startComponentTimer(countSec: number, callback: (second: number) => void): void {
        // 先終止已存在的timer
        this.cancelComponentTimer();

        this.componentTimer = new BackgroundTimer(countSec, (second) => {
            if (second < 0) {
                second = 0;
            }
            callback(second);

            if (second === 0) {
                this.cancelComponentTimer();
            }
        });

        this.componentTimer.start();
    }

    /**
     * 重置元件層級Timer
     */
    resetComponentTimer() {
        if (this.componentTimer != null) {
            this.componentTimer.reset();
        }
    }

    /**
     * 中斷元件層級Timer
     */
    cancelComponentTimer() {
        if (this.componentTimer != null) {
            this.componentTimer.cancel();
            this.componentTimer = null;
        }
    }
}

class BackgroundTimer {

    interval: number;
    tickInterval: number;
    tickCallback: (num: number) => void;
    tickingEnabled: boolean;
    running: boolean;
    hasExecCallback: boolean;
    expirationDate: number;
    tickerID;

    constructor(totalCountdownSec: number, everySecCallback: (second: number) => void) {
        this.interval = totalCountdownSec * 1000;
        this.tickInterval = 1000;
        this.tickCallback = everySecCallback;
        this.tickingEnabled = everySecCallback ? true : false;
        this.running = false;
        this.hasExecCallback = false;
    }

    start() {
        this.expirationDate = new Date().getTime() + this.interval;
        if (this.tickingEnabled) {
            this.startTicking();
        } else {
            return;
        }
        return this.running = true;
    }

    reset() {
        this.expirationDate = new Date().getTime() + this.interval;
    }

    getRemaining() {
        return this.expirationDate - new Date().getTime();
    }

    resume() {
        if (this.running) {
            this.cancel();
            const b = this.getRemaining();
            if (b > 0) {
                this.running = true; this.startTicking(); return;
            } else {
                if (!this.hasExecCallback) {
                    this.hasExecCallback = true; this.tickCallback(0);
                }
                return;
            }
        } else { this.pauseTicking(); }
    }

    pauseTicking() {
        if (this.tickerID) {
            clearInterval(this.tickerID);
            return this.tickerID = null;
        }
    }

    startTicking() {
        if (this.tickingEnabled) {
            this.pauseTicking();
            return this.tickerID = setInterval(((b) => {
                return () => {
                    if (b.running) {
                        const d = b.getRemaining();
                        if (d <= 0) {
                            b.running = false; b.pauseTicking();
                            if (!b.hasExecCallback) {
                                b.hasExecCallback = true;
                                b.tickCallback(0)
                            }
                        } else {
                            const c = Math.floor((b.getRemaining() + 100) / 1000);
                            if (c === 0) {
                                b.running = false; b.pauseTicking();
                                if (!b.hasExecCallback) {
                                    b.hasExecCallback = true;
                                    b.tickCallback(0);
                                }
                            } else { b.tickCallback(c); }
                        }
                    } else { b.pauseTicking(); }
                };
            })(this), this.tickInterval);
        }
    }

    cancel() {
        if (this.running) {
            this.running = false;
            this.pauseTicking();
        }
    }

}
